import { Link } from 'react-router-dom';

const seriesList = [
  {
    id: 'spotify-ui',
    label: 'UI再現実験',
    title: 'Spotify風UIを\nゼロから再現する',
    description: 'デザインを見て「作れそう」と思ったものを、AIだけで再現していく実験ログ。詰まった箇所と解決策を全部残す。',
    progress: 3,
    total: 6,
    status: '進行中',
    tags: ['UI再現', 'React', 'Cursor'],
    slug: 'ai-creation',
  },
  {
    id: 'ai-article-flow',
    label: 'AI記事制作',
    title: 'AI記事制作フローを\n仕様化する',
    description: '記事を書くプロセス自体をAIで効率化・仕様化する試み。プロンプト設計から構成・校正まで一気通貫で整理中。',
    progress: 2,
    total: 5,
    status: '進行中',
    tags: ['制作フロー', 'プロンプト', 'ChatGPT'],
    slug: 'build-log',
  },
  {
    id: 'this-site',
    label: 'サイト制作記録',
    title: 'このサイトを\n作った全記録',
    description: 'Readdy.aiでブログを立ち上げた7日間の全記録。仕様決め・デザイン・SEO・Supabase連携まで一通り残す。',
    progress: 4,
    total: 6,
    status: '進行中',
    tags: ['制作記録', 'Readdy', 'Supabase'],
    slug: 'build-log',
  },
];

export function SeriesSection() {
  return (
    <section className="py-14 sm:py-20 bg-[#F5EFE6]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">

        {/* Section header */}
        <div className="flex items-baseline justify-between mb-8 sm:mb-10">
          <div>
            <p
              className="text-xs font-semibold tracking-widest uppercase text-[#5B7B6F] mb-2"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              In Progress
            </p>
            <h2
              className="text-xl sm:text-2xl font-bold text-[#2C2416]"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              進行中シリーズ
            </h2>
          </div>
          <Link
            to="/articles"
            className="text-xs text-[#7A6E62] hover:text-[#2C2416] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            すべて見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Series cards */}
        <div className="space-y-4">
          {seriesList.map((series) => (
            <Link
              key={series.id}
              to={`/categories/${series.slug}`}
              className="block bg-[#FDFAF6] border border-[#E8E0D5] rounded-lg p-5 sm:p-6 hover:border-[#C8BFB5] transition-colors cursor-pointer group"
            >
              <div className="flex items-start justify-between gap-4 mb-3">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-2">
                    <span
                      className="text-xs font-semibold text-[#5B7B6F]"
                      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                    >
                      {series.label}
                    </span>
                    <span className="inline-flex items-center gap-1 text-[10px] font-medium text-[#9A8E84] bg-[#F0EBE3] px-2 py-0.5 rounded-full">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#5B7B6F] inline-block"></span>
                      {series.status}
                    </span>
                  </div>
                  <h3
                    className="text-base sm:text-lg font-bold text-[#2C2416] leading-snug group-hover:text-[#5B7B6F] transition-colors whitespace-pre-line"
                    style={{ fontFamily: "'Noto Serif JP', serif" }}
                  >
                    {series.title}
                  </h3>
                </div>
                <div className="flex-shrink-0 text-right">
                  <p
                    className="text-xs text-[#9A8E84]"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {series.progress}/{series.total}本
                  </p>
                </div>
              </div>

              <p
                className="text-sm text-[#7A6E62] leading-relaxed mb-4"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {series.description}
              </p>

              {/* Progress bar */}
              <div className="mb-4">
                <div className="h-1 bg-[#EDE7DF] rounded-full overflow-hidden">
                  <div
                    className="h-full bg-[#5B7B6F] rounded-full transition-all"
                    style={{ width: `${(series.progress / series.total) * 100}%` }}
                  ></div>
                </div>
              </div>

              {/* Tags */}
              <div className="flex flex-wrap gap-1.5">
                {series.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-[11px] text-[#9A8E84] bg-[#F0EBE3] px-2 py-0.5 rounded"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}
